import React from 'react';
import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { ThemedText } from '../themed-text';
import { cn } from '@/utils/cn';
import { PressableCard } from './card';
import { PressableScale } from './pressable-scale';

export interface OptionCardProps {
  /** Ícone exibido no círculo à esquerda */
  icon: React.ComponentProps<typeof Ionicons>['name'];
  title: string;
  subtitle?: string;
  onPress: () => void;
  /** Quando definido, mostra um botão de excluir à direita */
  onDelete?: () => void;
  /** Destaca o card como opção principal (círculo laranja cheio) */
  highlighted?: boolean;
  className?: string;
  testID?: string;
}

/**
 * Card de opção para telas de escolha (ex.: "como deseja criar?").
 * Ícone em círculo, título, subtítulo e chevron — com feedback de escala.
 */
export function OptionCard({
  icon,
  title,
  subtitle,
  onPress,
  onDelete,
  highlighted = false,
  className,
  testID,
}: OptionCardProps) {
  return (
    <PressableCard
      onPress={onPress}
      className={cn('flex-row items-center gap-3 p-4', className)}
      testID={testID}
    >
      <View
        className={cn(
          'h-11 w-11 items-center justify-center rounded-full',
          highlighted ? 'bg-primary' : 'bg-primary/10 dark:bg-primary',
        )}
      >
        <Ionicons
          name={icon}
          size={20}
          className={highlighted ? 'text-white' : 'text-primary dark:text-white'}
        />
      </View>
      <View className="flex-1 gap-0.5">
        <ThemedText className="font-semibold text-base text-neutral-900">{title}</ThemedText>
        {subtitle ? (
          <ThemedText className="text-sm leading-5 text-neutral-500">{subtitle}</ThemedText>
        ) : null}
      </View>
      {onDelete ? (
        <PressableScale
          onPress={onDelete}
          haptic
          accessibilityRole="button"
          accessibilityLabel={`Excluir ${title}`}
          className="h-10 w-10 items-center justify-center rounded-full"
          hitSlop={8}
        >
          <Ionicons className="text-error-500" name="trash-outline" size={19} />
        </PressableScale>
      ) : (
        <Ionicons className="text-neutral-400" name="chevron-forward" size={18} />
      )}
    </PressableCard>
  );
}
